export const SET_FULL_ACCESS = 'SET_FULL_ACCESS';

export interface MessageAction {
  type: typeof SET_FULL_ACCESS;

  payload: any;
}

export function setFullAccess(access: boolean): FullAccessTypes {
  return {
    type: SET_FULL_ACCESS,
    payload: { access },
  };
}

export type FullAccessTypes = MessageAction;
try {
    // @ts-ignore
    setFullAccess.displayName = "setFullAccess";
    // @ts-ignore
    setFullAccess.__docgenInfo = { "description": "", "displayName": "setFullAccess", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/FullAccess/actions/fullaccess.actions.ts#setFullAccess"] = { docgenInfo: setFullAccess.__docgenInfo, name: "setFullAccess", path: "src/shared/containers/FullAccess/actions/fullaccess.actions.ts#setFullAccess" };
}
catch (__react_docgen_typescript_loader_error) { }